<template>
  <div :class="iconBoxClasses">
    <span class="icon-box__icon">
      <img class="icon-box__img"
           :src="callBox.icon" />
    </span>

    <h2 class="icon-box__title"
        :class="status">
      <span v-if="!callBox.enableConvert">{{ callBox.title }}</span>
      <span v-else>{{ convertTime(callBox.title) }}</span>
    </h2>

    <p class="icon-box__text">
      {{ callBox.text }}
    </p>
  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    name: 'IconBox',
    props: {
      callBox: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        status: '',
      };
    },
    computed: {
      iconBoxClasses() {
        return `icon-box icon-box--${this.callBox.size}`;
      },
    },
    methods: {
      convertTime(seconds) {
        const duration = moment.duration(seconds, 'seconds');
        const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
        const minutes = duration.minutes().toString().padStart(2, '0');
        const secs = duration.seconds().toString().padStart(2, '0');

        return `${hours}:${minutes}:${secs}`;
      },
    },
    beforeMount() {
      if (this.callBox.size === 'full') {
        if (this.callBox.title === 0) {
          this.status = 'icon-box__title--green';
        } else if (this.callBox.title <= 9) {
          this.status = 'icon-box__title--yellow';
        } else if (this.callBox.title >= 9) {
          this.status = 'icon-box__title--red';
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
.icon-box {
  width: 100%;
  padding: 32px;
  border-radius: 8px;
  position: relative;
  background: var(--shadesWhite);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__icon {
    position: absolute;
    left: 0;
    top: 0;
    width: 40px;
    height: 40px;
    border-radius: 8px 0px;
    background-color: var(--neutral100);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__img {
    width: 20px;
    height: 20px;
  }

  &__title {
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 1;
    color: var(--color-base-900);
    text-align: center;
    margin-block-end: 16px;
  }

  &__text {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    text-transform: capitalize;
    text-align: center;
    color: var(--gray500);
  }

  &--half {
    height: 168px;
  }

  &--full {
    grid-column: 1;
    height: 100%;
    grid-row: 1 / 3;

    @include responsive(max, 991px) {
      grid-column: unset;
      grid-row: unset;
    }

    .icon-box__title {
      font-size: 64px;
      font-style: normal;
      font-weight: 400;
      line-height: 1;

      @include responsive(max, 991px) {
        font-size: 24px;
      }

      &--green {
        color: var(--green500);
        margin-block-end: 8px;
      }

      &--yellow {
        color: var(--warning500);
      }

      &--red {
        color: var(--redColor);
      }
    }

    .icon-box__text {
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 1;

      @include responsive(max, 991px) {
        font-size: 14px;
      }
    }
  }
}

:root[data-theme='dark'] {
  .icon-box__title {
    color: var(--shadesBlack);
  }
}
</style>
